export var EActionTypes;

(function (EActionTypes) {
  EActionTypes["FLAT_AREA_SUCCESS_RESPONSE"] = "FlatAreasSuccessResponse";
})(EActionTypes || (EActionTypes = {}));